import React from 'react';
import SupportPage from '../components/Support/SupportPage';

export default function Support({ navigate }) {
  return (
    <div className="wow-page">
      <div className="wow-motion-layer" aria-hidden="true">
        <span className="wow-orb orb-a"></span>
        <span className="wow-orb orb-b"></span>
        <span className="wow-orb orb-c"></span>
        <span className="wow-orb orb-d"></span>
        <span className="wow-ring ring-a"></span>
        <span className="wow-ring ring-b"></span>
        <span className="wow-pulse"></span>
      </div>
      <div className="wow-content container-fluid">
        <SupportPage navigate={navigate} />
      </div>
    </div>
  );
}
